import { SignUpScreen } from '@bounty/creators-common/screens/auth/auth'
import { GetStaticPropsWithSEO } from '@bounty/creators-common/types'
import { withSEO } from '../withSEO'

export const getStaticProps: GetStaticPropsWithSEO = async () => {
  return {
    props: {
      isSignUpMode: true,
      seo: {
        title: 'Bounty | Sign Up',
        description: `Sign up to Bounty and get paid cash back for sharing products you love on TikTok. It's the easiest way to get paid as a creator.`,
      },
    },
  }
}

export default withSEO(SignUpScreen)
